import { Injectable } from '@angular/core';
import {
  Order,
  PaginationService,
  QueryParams,
  TotvsListParamsFactoryService,
  TotvsPage,
} from 'ats-ui-lib';
import { JobOpportunityListItem } from '../job-opportunity-list-state/job-opportunity-list-state.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class JobOpportunityService implements PaginationService<JobOpportunityListItem> {
  constructor(
    private http: HttpClient,
    private paramsFactory: TotvsListParamsFactoryService,
  ) {}

  getAll(
    page: number,
    pageSize: number,
    filter?: string,
    order?: Order<JobOpportunityListItem>,
    advancedFilter?: QueryParams,
  ): Observable<TotvsPage<any>> {
    if (
      order != null &&
      order.length > 0 &&
      order.filter((x) => x.field === 'dateTimePublication').length === 0
    ) {
      order = [...order, { field: 'dateTimePublication', asc: true }];
    }
    const params = this.paramsFactory.createParams<JobOpportunityListItem>(
      page,
      pageSize,
      filter,
      order,
      advancedFilter,
    );

    return this.http.request<TotvsPage<JobOpportunityListItem>>(
      'OPTIONS',
      `${environment.jobPortalUrl}/api/job-opportunity/search`,
      {
        params,
        body: {
          filter: params.filter,
          ...advancedFilter,
        },
      },
    );
  }
}
